import { render, staticRenderFns } from "./DeviceAlarmSetup.vue?vue&type=template&id=da62c5b4&scoped=true"
import script from "./DeviceAlarmSetup.vue?vue&type=script&lang=ts"
export * from "./DeviceAlarmSetup.vue?vue&type=script&lang=ts"
import style0 from "./DeviceAlarmSetup.vue?vue&type=style&index=0&id=da62c5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da62c5b4",
  null
  
)

export default component.exports